import { TStepResponse } from "model/program";
import React, { ForwardedRef, useMemo } from "react";

import { ProgramVideoList } from "../ProgramVideoList/ProgramVideoList";
import {
  ProgramSectionItemStyled,
  SectionStepper,
} from "./ProgramSectionItem.styled";

type TProps = {
  section: TStepResponse;
  type?: string;
  isUpdate?: boolean;
};

const ProgramSectionItem = (props: TProps, ref: ForwardedRef<any>) => {
  const { section, type, isUpdate } = props;
  const sectionStepperComponent = useMemo(() => {
    return (
      <SectionStepper>
        <span className="content">{`${section?.stepName}`}</span>
      </SectionStepper>
    );
  }, [section?.stepName]);

  return (
    <ProgramSectionItemStyled ref={ref}>
      {sectionStepperComponent}
      <ProgramVideoList
        type={type}
        videos={section?.shumokus}
        isUpdate={isUpdate}
      />
    </ProgramSectionItemStyled>
  );
};

const ProgramSectionItemRef = React.forwardRef(ProgramSectionItem);

export { ProgramSectionItemRef };
